interface TooltipFieldInfoProps {
  fieldName: string
  area: number
  diagnosticsCount?: number
}

export const createTooltipHTML = ({
  fieldName,
  area,
  diagnosticsCount,
}: TooltipFieldInfoProps): string => {
  const diagnosticsCountText =
    (diagnosticsCount && diagnosticsCount == 0) ||
    (diagnosticsCount && diagnosticsCount == 1) ||
    !diagnosticsCount
      ? 'Dados insuficientes para análise'
      : `${diagnosticsCount} diagnósticos disponíveis`

  return `
    <div style="
      display: flex;
      flex-direction: column;
      gap: 6px;
      border-radius: 5px;
      background-color: white;
      color: #001D29;
      font-weight: 600;
      font-size: 11px;
      font-family: 'Source Sans Pro', sans-serif;
      max-width: 250px;
      min-width: 200px;
      word-wrap: break-word;
      overflow-wrap: break-word;
      word-break: break-word;
      white-space: normal;
      line-height: 1.3;
      opacity: 1;
      fill-opacity: 1;
    ">
      <span style="
        word-wrap: break-word;
        overflow-wrap: break-word;
        word-break: break-word;
        white-space: normal;
        font-weight: 600;
      ">${fieldName}</span>
      <span>Área: ${area} ha</span>
      <span>${diagnosticsCountText}</span>
    </div>
  `
}
